module.exports = __webpack_public_path__ + "img/error-404.fdc0a005.png";